const SESSION_STORAGE_KEY = "merch_session_id";

const createFallbackId = () =>
  `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;

export function getSessionId() {
  if (typeof window === "undefined") {
    return "";
  }

  try {
    let sessionId = window.localStorage.getItem(SESSION_STORAGE_KEY);

    if (!sessionId) {
      sessionId =
        typeof crypto !== "undefined" &&
        typeof crypto.randomUUID === "function"
          ? crypto.randomUUID()
          : createFallbackId();

      window.localStorage.setItem(SESSION_STORAGE_KEY, sessionId);
    }

    return sessionId;
  } catch (error) {
    console.error("Unable to access the merchandise session ID:", error);
    return createFallbackId();
  }
}

export function resetSessionId() {
  if (typeof window === "undefined") {
    return "";
  }

  try {
    window.localStorage.removeItem(SESSION_STORAGE_KEY);
  } catch (error) {
    console.error("Unable to reset the merchandise session ID:", error);
  }

  return getSessionId();
}
